

























































































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
  dispatchType = 'stadium/manager';

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '头像', scopedSlots: { customRender: 'avatar' } },
    { title: '用户名', dataIndex: 'username' },
    { title: '手机号(归属地)', scopedSlots: { customRender: 'mobile' } },
    { title: '时间', dataIndex: 'created_time' },
    { title: '操作', scopedSlots: { customRender: 'action' } },
  ];

  mounted() {
    this.loadData();
  }
}
